(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCartDrawer() {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer || drawer.dataset.cartReady === 'true') return;
      drawer.dataset.cartReady = 'true';

      var body = drawer.querySelector('[data-cart-body]');
      var checkout = drawer.querySelector('[data-cart-checkout]');
      var emptyLabel = drawer.getAttribute('data-cart-empty') || 'Your cart is empty.';
      var removeLabel = drawer.getAttribute('data-cart-remove-label') || 'Remove';
      var root = drawer.getAttribute('data-cart-root') || '/';
      var refreshPromise = null;

      function escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function itemImageUrl(item) {
        var src =
          (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
          item.image ||
          '';
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_120x$1$2');
      }

      function renderCart(cart) {
        if (!body) return;

        var countEl = document.querySelector('[data-cart-count-live]');
        if (countEl) {
          countEl.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
        }

        if (checkout) {
          if (cart.item_count > 0) checkout.removeAttribute('hidden');
          else checkout.setAttribute('hidden', '');
        }

        if (!cart.items || cart.items.length === 0) {
          body.innerHTML = '<p>' + escapeHtml(emptyLabel) + '</p>';
          return;
        }

        body.innerHTML =
          '<ul>' +
          cart.items
            .map(function (item) {
              var title = escapeHtml(item.product_title || item.title || '');
              var url = escapeHtml(item.url || '#');
              var image = itemImageUrl(item);
              var imageHtml = image
                ? '<img class="cart-drawer__item-image" src="' +
                  escapeHtml(image) +
                  '" alt="" width="48" height="48" loading="lazy">'
                : '';
              var key = escapeHtml(item.key || String(item.id || ''));
              return (
                '<li class="cart-drawer__item">' +
                '<a class="cart-drawer__item-main" href="' +
                url +
                '">' +
                imageHtml +
                '<span class="cart-drawer__item-title">' +
                title +
                '</span></a>' +
                '<div class="cart-drawer__item-meta">' +
                '<span class="cart-drawer__item-qty">× ' +
                Number(item.quantity) +
                '</span>' +
                '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-line="' +
                key +
                '">' +
                escapeHtml(removeLabel) +
                '</button></div></li>'
              );
            })
            .join('') +
          '</ul>';
      }

      function refreshCart() {
        if (!window.fetch) return Promise.resolve();
        if (refreshPromise) return refreshPromise;
        refreshPromise = fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart_fetch_failed');
            return res.json();
          })
          .then(function (cart) {
            renderCart(cart);
          })
          .catch(function () {})
          .then(function () {
            refreshPromise = null;
          });
        return refreshPromise;
      }

      function removeLine(key, button) {
        if (!window.fetch || !key) return;
        if (button) button.disabled = true;
        fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart_change_failed');
            return res.json();
          })
          .then(function (cart) {
            renderCart(cart);
          })
          .catch(function () {
            refreshCart();
          });
      }

      function openDrawer() {
        refreshCart().then(function () {
          if (typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
        });
      }

      function closeDrawer() {
        if (drawer.open) drawer.close();
      }

      document.addEventListener('click', function (event) {
        var openTrigger = event.target.closest('[data-cart-open]');
        if (openTrigger) {
          event.preventDefault();
          openDrawer();
          return;
        }
        if (event.target.closest('[data-cart-close]')) {
          closeDrawer();
          return;
        }
        var removeTrigger = event.target.closest('[data-cart-remove]');
        if (removeTrigger && drawer.contains(removeTrigger)) {
          event.preventDefault();
          removeLine(removeTrigger.getAttribute('data-line'), removeTrigger);
        }
      });

      document.addEventListener('cart:updated', refreshCart);
      document.addEventListener('cart:open', openDrawer);
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDrawer();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'lescargot-privacy';
    var root = document.querySelector('[data-cookie-consent]');
    if (!root) return;

    var banner = root.querySelector('[data-cookie-banner]');
    var dialog = root.querySelector('[data-privacy-settings-dialog]');
    var form = root.querySelector('[data-privacy-form]');
    var bannerRequired = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    function getGpc() {
      return navigator.globalPrivacyControl === true;
    }

    function granted(value) {
      return value ? 'granted' : 'denied';
    }

    function readStored() {
      try {
        return JSON.parse(sessionStorage.getItem(KEY) || localStorage.getItem(KEY) || 'null');
      } catch (error) {
        return null;
      }
    }

    function writeStored(record) {
      var payload = JSON.stringify(record);
      try {
        sessionStorage.setItem(KEY, payload);
        if (record.decided) localStorage.setItem(KEY, payload);
      } catch (error) {}
    }

    function callFirst(api, names) {
      if (!api) return undefined;
      for (var i = 0; i < names.length; i += 1) {
        if (typeof api[names[i]] === 'function') return api[names[i]]();
      }
      return undefined;
    }

    function sessionFromDom(api) {
      var session = Object.assign({}, window.__LESCARGOT_PRIVACY_SESSION__ || {});
      session.locale = session.locale || root.getAttribute('data-locale') || '';
      session.country = session.country || root.getAttribute('data-country') || '';
      session.currency = session.currency || root.getAttribute('data-currency') || '';
      session.template = session.template || root.getAttribute('data-template') || '';
      session.customer = session.customer || root.getAttribute('data-customer') || 'guest';
      session.shop = session.shop || root.getAttribute('data-shop') || '';
      session.gpc = getGpc();
      if (api) {
        session.shopify_region = callFirst(api, ['getRegion']) || '';
        session.sale_of_data_region = !!callFirst(api, ['saleOfDataRegion', 'saleOfDataRegion']);
        session.banner_required = bannerRequired;
      }
      return session;
    }

    function applyGpcUi() {
      var gpc = getGpc();
      root.querySelectorAll('[data-gpc-notice]').forEach(function (el) {
        el.hidden = !gpc;
      });
      root.querySelectorAll('[data-gpc-lock]').forEach(function (el) {
        el.hidden = !gpc;
      });
      ['[data-consent-marketing]', '[data-consent-sale]'].forEach(function (selector) {
        var input = root.querySelector(selector);
        if (!input) return;
        if (gpc) {
          input.checked = false;
          input.disabled = true;
        } else {
          input.disabled = false;
        }
      });
    }

    function hydrateForm(consent) {
      var prefs = root.querySelector('[data-consent-preferences]');
      var analytics = root.querySelector('[data-consent-analytics]');
      var marketing = root.querySelector('[data-consent-marketing]');
      var sale = root.querySelector('[data-consent-sale]');
      if (prefs) prefs.checked = !!consent.preferences;
      if (analytics) analytics.checked = !!consent.analytics;
      if (marketing) marketing.checked = !!consent.marketing;
      if (sale) sale.checked = !!consent.sale_of_data;
      applyGpcUi();
    }

    function readForm() {
      return {
        analytics: !!(root.querySelector('[data-consent-analytics]') || {}).checked,
        preferences: !!(root.querySelector('[data-consent-preferences]') || {}).checked,
        marketing: !!(root.querySelector('[data-consent-marketing]') || {}).checked,
        sale_of_data: !!(root.querySelector('[data-consent-sale]') || {}).checked
      };
    }

    function setShopifyConsent(consent) {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.setTrackingConsent !== 'function') return;
      try {
        api.setTrackingConsent(
          {
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            preferences: !!consent.preferences,
            sale_of_data: !!consent.sale_of_data
          },
          function () {}
        );
      } catch (error) {}
    }

    function applyConsent(consent, options) {
      options = options || {};
      var gpc = getGpc();
      var next = {
        analytics: !!consent.analytics,
        preferences: !!consent.preferences,
        marketing: gpc ? false : !!consent.marketing,
        sale_of_data: gpc ? false : !!consent.sale_of_data
      };
      var gtagState = {
        analytics_storage: granted(next.analytics),
        ad_storage: granted(next.marketing),
        ad_user_data: granted(next.marketing),
        ad_personalization: granted(next.marketing),
        personalization_storage: granted(next.preferences),
        functionality_storage: 'granted',
        security_storage: 'granted'
      };
      window.gtag('consent', 'update', gtagState);
      window.gtag('set', 'ads_data_redaction', !next.marketing);
      var session = sessionFromDom(window.Shopify && window.Shopify.customerPrivacy);
      session.consent_source = options.source || 'user';
      var payload = {
        event: options.event || 'consent_update',
        gpc: gpc,
        consent: {
          analytics: gtagState.analytics_storage,
          marketing: gtagState.ad_storage,
          preferences: gtagState.personalization_storage,
          sale_of_data: granted(next.sale_of_data),
          essential: 'granted'
        },
        session: session
      };
      window.dataLayer.push(payload);
      var record = {
        decided: options.persist !== false,
        analytics: next.analytics,
        marketing: next.marketing,
        preferences: next.preferences,
        sale_of_data: next.sale_of_data,
        gpc: gpc,
        source: session.consent_source,
        updated_at: new Date().toISOString()
      };
      writeStored(record);
      if (options.shopify !== false) setShopifyConsent(next);
      window.__LESCARGOT_PRIVACY__ = Object.assign({}, record, { session: session });
      hydrateForm(next);
      return next;
    }

    function shopifyDecision(api) {
      var current = callFirst(api, ['currentVisitorConsent', 'currentVisitorConsent']);
      if (!current) return null;
      var keys = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
      var decided = false;
      var mapped = {};
      keys.forEach(function (key) {
        var value = current[key];
        if (value === 'yes' || value === true) {
          mapped[key] = true;
          decided = true;
        } else if (value === 'no' || value === false) {
          mapped[key] = false;
          decided = true;
        } else {
          mapped[key] = false;
        }
      });
      return decided ? mapped : null;
    }

    function showBanner() {
      if (banner) banner.hidden = false;
    }

    function hideBanner() {
      if (banner) banner.hidden = true;
    }

    function openSettings() {
      hydrateForm(window.__LESCARGOT_PRIVACY__ || readStored() || {});
      hideBanner();
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    }

    function closeSettings() {
      if (dialog && dialog.open) dialog.close();
    }

    function withPrivacyApi(done) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        done(null);
        return;
      }
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            done(null);
            return;
          }
          done(window.Shopify.customerPrivacy || null);
        }
      );
    }

    applyGpcUi();

    var accept = root.querySelector('[data-consent-accept]');
    var reject = root.querySelector('[data-consent-reject]');
    var customize = root.querySelector('[data-consent-customize]');
    var closeBtn = root.querySelector('[data-privacy-close]');

    if (accept) {
      accept.addEventListener('click', function () {
        applyConsent(
          { analytics: true, preferences: true, marketing: true, sale_of_data: true },
          { persist: true, source: 'user', event: 'consent_update' }
        );
        hideBanner();
        closeSettings();
      });
    }

    if (reject) {
      reject.addEventListener('click', function () {
        applyConsent(
          { analytics: false, preferences: false, marketing: false, sale_of_data: false },
          { persist: true, source: 'user', event: 'consent_update' }
        );
        hideBanner();
        closeSettings();
      });
    }

    if (customize) customize.addEventListener('click', openSettings);
    if (closeBtn) closeBtn.addEventListener('click', closeSettings);

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        applyConsent(readForm(), { persist: true, source: 'user', event: 'consent_update' });
        hideBanner();
        closeSettings();
      });
    }

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeSettings();
      });
      dialog.addEventListener('close', function () {
        var stored = readStored();
        if (bannerRequired && (!stored || !stored.decided)) showBanner();
      });
    }

    document.querySelectorAll('[data-privacy-settings]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        openSettings();
      });
    });

    withPrivacyApi(function (api) {
      var stored = readStored();
      var gpc = getGpc();
      var fromShopify = shopifyDecision(api);
      var decided = stored && stored.decided;
      if (!decided && fromShopify) {
        stored = Object.assign({ decided: true, source: 'shopify' }, fromShopify);
        decided = true;
      }

      if (api) {
        var show = callFirst(api, ['shouldShowBanner', 'shouldShowBanner']);
        bannerRequired = typeof show === 'boolean' ? show : !decided;
      } else {
        bannerRequired = !decided;
      }

      if (decided) {
        applyConsent(stored, {
          persist: true,
          shopify: false,
          source: stored.source || 'stored',
          event: 'session_privacy'
        });
        hideBanner();
        return;
      }

      if (bannerRequired) {
        showBanner();
        applyConsent(
          { analytics: false, marketing: false, preferences: false, sale_of_data: false },
          { persist: false, shopify: false, source: gpc ? 'gpc' : 'default', event: 'session_privacy' }
        );
        return;
      }

      applyConsent(
        { analytics: true, marketing: !gpc, preferences: true, sale_of_data: !gpc },
        { persist: true, shopify: false, source: gpc ? 'gpc' : 'region', event: 'session_privacy' }
      );
      hideBanner();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["landing-splash"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'lescargot-landing-seen';
    var MIN_MS = 2000;
    var FADE_MS = 500;
    var MAX_MS = 5000;
    var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

    function init() {
      var splash = document.querySelector('[data-landing-splash]');
      if (!splash) return;

      try {
        if (localStorage.getItem(KEY)) {
          splash.remove();
          document.documentElement.classList.remove('landing-splash-pending');
          return;
        }
      } catch (e) {}

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        splash.remove();
        document.documentElement.classList.remove('landing-splash-pending');
        try {
          localStorage.setItem(KEY, '1');
        } catch (e) {}
        return;
      }

      var src = MOBILE_MQ.matches ? splash.dataset.mobile : splash.dataset.desktop;
      if (!src) {
        splash.remove();
        document.documentElement.classList.remove('landing-splash-pending');
        return;
      }

      var img = document.createElement('img');
      img.className = 'landing-splash__media';
      img.alt = '';
      img.decoding = 'sync';
      img.src = src;

      splash.appendChild(img);
      splash.hidden = false;
      splash.setAttribute('aria-hidden', 'false');

      var shownAt = Date.now();
      var done = false;

      function dismiss() {
        if (done) return;
        done = true;
        splash.classList.add('landing-splash--out');
        window.setTimeout(function () {
          splash.remove();
          document.documentElement.classList.remove('landing-splash-pending');
          document.body.style.overflow = '';
          try {
            localStorage.setItem(KEY, '1');
          } catch (e) {}
        }, FADE_MS);
      }

      function scheduleDismiss() {
        var wait = Math.max(0, MIN_MS - (Date.now() - shownAt));
        window.setTimeout(dismiss, wait);
      }

      if (img.complete) scheduleDismiss();
      else {
        img.addEventListener('load', scheduleDismiss);
        img.addEventListener('error', scheduleDismiss);
      }

      window.setTimeout(scheduleDismiss, MAX_MS);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
